import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const footerLinks = [
  {
    title: '文章分类',
    links: categories.map((cat) => ({ name: cat.name, href: `/category/${cat.slug}` })),
  },
  {
    title: '快速链接',
    links: [
      { name: '首页', href: '/' },
      { name: '关于我们', href: '/about' },
      { name: '症状', href: '/category/zhengzhuang' },
      { name: '治疗', href: '/category/zhiliao' },
      { name: '预防', href: '/category/yufang' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { name: '龟头责早期症状', href: '/article/guitouze-zaoqi-zhengzhuang' },
      { name: '龟头责原因分析', href: '/article/guitouze-bingyin-fenxi' },
      { name: '龟头责治疗方法', href: '/article/guitouze-zhiliao-fangan' },
      { name: '龟头责预防措施', href: '/article/guitouze-yufang-cuoshi' },
      { name: '龟头责常用药物', href: '/article/guitouze-changyong-yaowu' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-shield-cross-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
                男性健康科普
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              专注于男性生殖健康科普的权威平台，提供龟头责等男性常见疾病的知识普及与防治指导，帮助广大男性朋友守护生殖健康。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 男性健康科普中心 版权所有 | 本站内容仅供参考，不构成医疗建议
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">免责声明</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}